const e = "recently-viewed";
class r {
  constructor() {
    this.recentlyViewedHandles = [], this.recentlyViewedHandles = JSON.parse(
      localStorage.getItem(e) || "[]"
    );
  }
  add(t) {
    this.recentlyViewedHandles = Array.from(
      new Set([t, ...this.recentlyViewedHandles].slice(0, 20))
      // Keep track of 20 recently viewed products
    ), localStorage.setItem(
      e,
      JSON.stringify(this.recentlyViewedHandles)
    );
  }
  get() {
    return this.recentlyViewedHandles;
  }
  clear() {
    localStorage.removeItem(e), this.recentlyViewedHandles = [];
  }
  remove(t) {
    this.recentlyViewedHandles = this.recentlyViewedHandles.filter(
      (l) => l !== t
    ), localStorage.setItem(
      e,
      JSON.stringify(this.recentlyViewedHandles)
    );
  }
  list() {
    return this.recentlyViewedHandles;
  }
}
const n = new r();
export {
  n as r
};
